import { Injectable } from '@angular/core';
import { Subject, Observable, filter, map } from 'rxjs';

export interface EventData<T = any> {
  name: string;
  payload?: T;
  source?: string;
  target?: string;
  timestamp?: number;
}

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private eventSubject$ = new Subject<EventData>();
  
  constructor() {}

  // emit an event to all listeners
  emit<T>(event: string | EventData<T>, payload?: T, metadata?: Partial<EventData>): void {
    const eventData: EventData<T> = typeof event === 'string' 
      ? { 
          name: event, 
          payload, 
          timestamp: Date.now(),
          ...metadata 
        }
      : { 
          ...event, 
          timestamp: event.timestamp || Date.now() 
        };
    
    this.eventSubject$.next(eventData);
  }

  // listen to events
  on<T>(eventName: string): Observable<T> {
    return this.eventSubject$.pipe(
      filter(event => event.name === eventName),
      map(event => event.payload as T)
    );
  }

  // clear all event listeners
  destroy(): void {
    this.eventSubject$.complete();
  }
}
